// @flow
import * as React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { connect } from "react-redux";
import colors from '../../../assets/css/colors';
import {
	ModalContainer,
	ModalInnerTitle,
	ButtonPrimary,
	ButtonSecondary
} from '../../../components';
import { below } from "../../../assets/css/media";
import CountdownTimer from "../../../components/CountdownTimer";
import type { TRootStore } from "../../../modules/types";
import type { TPlayerWithFixture } from "../../../modules/types/player";
import * as selectors from "../../../modules/selectors";
import type { TPositionsById } from "../../../modules/types/position";

const ModalText = styled(ModalInnerTitle)`
	padding-top: 130px;
`;

const CountdownTimerStyled = styled(CountdownTimer)`
	justify-content: center;
	margin-top: 1.5em;

	& > div {
		background: white;
		padding: 0.6em;

	}

	.timer-unit{
		font-size: 30px;
	}

	.timer-label{
		font-size: 12px;
		line-height: 1.33;
	}

	& > div {
		font-size: 30px;
	}
`;

const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0 1em;
	padding: 1em 0;

	button {
		text-transform: uppercase;
		min-width: 180px;
		margin: 0 5px;
		${below.desktop`
			min-width: 85px;
		`}
	}
`;

const StyledModal = styled(ModalContainer)`
	margin-top: 20px;
	position:relative;
	@media screen and (max-width: 480px){
		width: 100%;
	}
`;

const PlayerImgContainer = styled.div`
	text-align: center;
    position: absolute;
    left: 50%;
	top: 0;
    transform: translate(-50%, -25%);
    width: 40%;
	height: 50%;

    img{
    	width: 100%;
    	width: 282px;
		height:294px;
	    //max-width: 282px;
	    //max-height: 100%;
	    height: ;
	    display: inline-block;
	    margin-top:2.5em;
    }
	@media screen and (max-width: 480px){
		width: 100%;
		left: 50%;
		top: -6%;
	}
`;

const ButtonWrapperStyled = styled(ButtonWrapper)`
	justify-content: center;
	> button {
		margin: 0 5px;
	}
`;

const PickTimerHeader = styled.div`
	text-align: center;
	font-size: 20px;
	font-weight: bold;
	color: ${colors.nrlDarkGreen};
`;

type Props = {
	player: Object,
	pickMsg: Object,
	closeClick?: Function,
	confirmClick?: Function,
	player: TPlayerWithFixture,
	availablePositions: Array<string>,
	positions: TPositionsById,
	nextPickAt: string,
};

const MakePickPopupContainer = ({
	closeClick,
	confirmClick,
	player,
	pickMsg,
	availablePositions,
	positions,
	nextPickAt,
}: Props) => {
	const pos_size = _.size(availablePositions);
	const current_pick = _.get(pickMsg, 'pick', 1);

	return player ? (
		<StyledModal
			header_text={`PICK ${current_pick}`}
			onClick={closeClick}
			is_sponsored={true}
		>
			<PlayerImgContainer>
				<img src={`${process.env.REACT_APP_PLAYERS_PATH + player.id}.png`} alt=""/>
			</PlayerImgContainer>
			<ModalText>
				{`Are you sure you want to draft ${player.first_name} ${player.last_name}?`}
			</ModalText>
			<div>
				<PickTimerHeader>
					{`Pick ${current_pick} is on the clock`}
				</PickTimerHeader>
				<CountdownTimerStyled
					showOnComplete={true}
					hideHoursIfZero={true}
					date={nextPickAt}
				/>
			</div>
			{pos_size > 1 ? (
				<ButtonWrapperStyled>
					<ButtonSecondary onClick={closeClick}>
						Cancel
					</ButtonSecondary>
					{availablePositions.map(position_key => (
						<ButtonPrimary
							key={position_key}
							data-pos={position_key}
							data-id={player.id}
							onClick={confirmClick}
						>
							{[2,3,6,'2','3','6'].includes(position_key)?
								_.get(positions, `${position_key}.short_name`, 'Bench') :
								_.get(positions, `${position_key}.full_name`, 'Bench')
							}
						</ButtonPrimary>
					))}
				</ButtonWrapperStyled>
			) : null}
			<ButtonWrapper>
				{pos_size === 1 ? (
					<React.Fragment>
						<ButtonSecondary onClick={closeClick}>
							Cancel
						</ButtonSecondary>
						<ButtonPrimary
							data-pos={availablePositions[0]}
							data-id={player.id}
							onClick={confirmClick}
						>
						CONFIRM PICK
						</ButtonPrimary>
					</React.Fragment>
				) : null}
			</ButtonWrapper>
		</StyledModal>
	) : null;
};

const mapStateToProps = (state: TRootStore) => ({
	positions: selectors.positions.getPositionsById(state),
});

export const MakePickPopup = connect(
	mapStateToProps,
)(MakePickPopupContainer);

export default MakePickPopup;


// WEBPACK FOOTER //
// ./src/pages/league/liveDraft/makePickPopup.js